import api from './api';

const storageService = {
  /**
   * Get a pre-signed URL for uploading a receipt
   */
  getUploadUrl: async (fileName, contentType) => {
    const response = await api.post('/storage/receipt-upload-url', {
      fileName,
      contentType,
    });
    return response.data;
  },

  /**
   * Upload a file directly to Azure Blob Storage using the pre-signed URL
   * This is cost-effective as it bypasses our API
   */
  uploadReceipt: async (file, onProgress) => {
    // Step 1: Get the upload URL from our API
    const { uploadUrl, blobUrl } = await storageService.getUploadUrl(
      file.name,
      file.type
    );

    // Step 2: Upload directly to Azure Blob Storage
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': file.type,
      },
      body: file,
    });

    if (!response.ok) {
      throw new Error('Failed to upload receipt');
    }

    // Step 3: Return the permanent blob URL (without SAS token)
    return blobUrl;
  },

  /**
   * Get a time-limited read URL for viewing a receipt
   */
  getReadUrl: async (blobUrl) => {
    const response = await api.post('/storage/receipt-read-url', {
      blobUrl,
    });
    return response.data.readUrl;
  },

  /**
   * Delete a receipt from storage
   */
  deleteReceipt: async (blobUrl) => {
    const response = await api.delete('/storage/receipt', {
      params: { blobUrl },
    });
    return response.data;
  },
};

export default storageService;